


<template>
    <div class="page-sidebar" id="nav-page-sidebar"
    >
        <Loading v-model:active="isLoading">
        </Loading>

        <div class="logo-wrap resp-logo">
            <!-- Roomdera (also localhost:8080) -->
            <span v-if="hostUrl === roomderaHost">
                <a href="javascript:;" @click="goToHomeRoute" v-if="companyId=='DB69182F-9412-4139-BCF1-E7656AB63099'">
                    <img src="../../assets/images/logo/logo-light.png" style="width: 220px; " class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
                <a href="javascript:;" @click="goToHomeRoute" v-else>
                    <img src="../../assets/images/logo/logo-light.png" style="width:220px;" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
            </span>
            <!-- Briktok (also localhost:8082) -->
            <span v-else-if="hostUrl === briktokHost || hostUrl === 'localhost:8082'">
                <a href="javascript:;" @click="goToHomeRoute">
                    <img src="../../assets/images/logo/logo-w.png" style="width:220px;" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
            </span>

            <!-- BoatDera -->
            <span v-else-if="hostUrl === boatderaHost">
                <a href="javascript:;" @click="goToHomeRoute">
                    <img src="https://boatdera.com/img/logo.png" style="width:220px;" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
            </span>

            <!-- PlaneDera (local files) -->
            <span v-else-if="hostUrl === planederaHost">
                <a href="javascript:;" @click="goToHomeRoute">
                    <img src="../../assets/images/logo/PlaneDera-light-logo.png" style="width:220px;" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
            </span>
            <!-- KidsDera -->
            <span v-else-if="hostUrl === kidsderaHost">
                <a href="javascript:;" @click="goToHomeRoute">
                    <img src="../../assets/images/logo/kids-logo-light.png" style="width:220px;" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
            </span>

            <!-- BizDera -->
            <span v-else-if="hostUrl === bizderaHost">
                <a href="javascript:;" @click="goToHomeRoute">
                    <img src="../../assets/images/logo/Biz-logo-light.png" style="width:220px;" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
            </span>

            <!-- ParentDera -->
            <span v-else-if="hostUrl === parentderaHost">
                <a href="javascript:;" @click="goToHomeRoute">
                    <img src="../../assets/images/logo/Parent-logo-light.png" style="width:220px;" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
            </span>
            <!-- HomeDera -->
            <span v-else-if="hostUrl === homederaHost">
                <a href="javascript:;" @click="goToHomeRoute">
                    <img src="../../assets/images/logo/Home-logo-light.png" style="width:220px;" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
            </span>

            <!-- RVDera -->
            <span v-else-if="hostUrl === rvderaHost  || hostUrl === 'localhost:8080'">
                <a href="javascript:;" @click="goToHomeRoute">
                    <img src="../../assets/images/logo/Rv-logo-light.png" style="width:220px;" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
            </span>
            <!-- Default (SPLIYT / everything else) -->
            <span v-else>
                <a href="javascript:;" @click="goToHomeRoute" v-if="companyId=='DB69182F-9412-4139-BCF1-E7656AB63099'">
                    <img :src="logoSecondary" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>
                <a href="javascript:;" @click="goToHomeRoute" v-else>
                    <img :src="logoPrimary" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
                </a>

            </span>

            <div class="back-btn d-lg-none d-inline-block" @click="toggleSlider">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-left"><polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline></svg>
            </div>
        </div>
        <div class="main-sidebar">

            <div id="mainsidebar">
                <ul class="sidebar-menu custom-scrollbar">
                    <li class="mobile-show">
                        <div class="user-profile">
                            <div class="media">
                                <div class="change-pic">
                                    <router-link v-if="userType == 'usertype01' || userType == 'usertype02' || userType == 'usertype04' ||userType == 'usertype06' ||userType == 'usertype11' ||userType == 'usertype12' " to="/userProfile" href="Javascript:;" @click="CheckRoute">
                                        <img :src="imageLink" class="img-fluid" alt="" v-if="$filters.IsNull(imageLink)!=null">
                                        <span class="avatarttext" v-if="$filters.IsNull(imageLink)==null">{{$filters.FirstAndLastNameAlpha(name.firstName,name.lastName)}}</span>
                                    </router-link>
                                    <router-link v-else to="/userProfile" @click="CheckRoute">
                                        <img :src="imageLink" class="img-fluid" alt="" v-if="$filters.IsNull(imageLink)!=null">
                                        <span class="avatarttext" v-if="$filters.IsNull(imageLink)==null">{{$filters.FirstAndLastNameAlpha(name.firstName,name.lastName)}}</span>
                                    </router-link>
                                </div>
                                <div class="media-body">
                                    <router-link to="/userProfile" @click="CheckRoute" href="javascript:;" v-if="(companyId != '526C12D1-97B1-4F5A-A454-147AAC613505' && companyId != '526c12d1-97b1-4f5a-a454-147aac613505')&&(userType == 'usertype01' || userType == 'usertype02' || userType == 'usertype04' ||userType == 'usertype06' ||userType == 'usertype11' ||userType == 'usertype12')"><h6>{{name.firstName}} {{name.lastName}}</h6></router-link>
                                    <router-link to="/userProfile" @click="CheckRoute" href="javascript:;" v-else><h6>{{name.firstName}} {{name.lastName}}</h6></router-link>

                                    <h6 v-if="companyId == '526C12D1-97B1-4F5A-A454-147AAC613505' || companyId == '526c12d1-97b1-4f5a-a454-147aac613505'">{{name.firstName}} {{name.lastName}}</h6>
                                    <span v-if="headerData!=null && headerData!='' && headerData.userType!='Co-owner'  && headerData.userType!='Seller' && headerData.userType!='Ambassador' && headerData.userType!='Realtor'">
                                        <span v-if="assetType === 'Household' && loginSource !== 'Mobile' && headerData.userType !='Friend' && headerData.userType !='Parents' && headerData.userType !='Guest'">
                                            Primary Roommate
                                        </span>
                                        <span v-else-if="loginSource === 'Mobile' && headerData.userType !='Friend' && headerData.userType !='Parents' && headerData.userType !='Friend' &&  headerData.userType !='Guest'">
                                            <span v-if="assetType === 'Household'">
                                                Primary Roommate
                                            </span>
                                            <span v-else>Owner</span>
                                        </span>
                                        <span v-else>{{ formatHeaderUserType(headerData.userType) }}</span>
                                    </span>
                                    <span v-if="(headerData!=null && headerData!='' && (headerData.userType=='Co-owner'  || headerData.userType=='Ambassador' || headerData.userType=='Seller' || headerData.userType=='Realtor'))">
                                        {{ formatHeaderUserType(headerData.userType) }}
                                    </span>
                                </div>
                            </div>
                        </div>


                    </li>
                    <!--<li class="edit-sidebar-action">
                        <button type="button"
                                class="edit-sidebar-cta"
                                @click="goToEditSidebar"
                                aria-label="Edit Menus">
                            <span class="edit-sidebar-cta__icon" aria-hidden="true">
                                <i class="fa fa-sliders"></i>
                            </span>
                            <span class="edit-sidebar-cta__label">Edit Menus</span>
                        </button>
                    </li>-->

                    <li :class="['sidebar-link', 'only-link', rootGroupParentLiClass(item)]" v-for="(item,index) in moduleList" v-bind:key="item.moduleId">

                        <a href="javascript:void(0)" class="sidebar-link single_click only-link"
                           v-if="!item.subModules && item.moduleCode!='999999999' && item.categoryModules==null"
                           @click="redirectToPath(item.moduleRoute)" :title="[$t(`sidebar.${item.moduleName}`)]"
                           :class="[{'active':checkCurrentRoute(item)},'menuElelment_'+ item.moduleId]"
                           :active="index === activeIndex" :attribute-id="[item.moduleId]">
                            <vue-feather v-if="shouldShowSidebarMenuIcon(item, { level: 'root' })" :type="item.moduleCssClass"></vue-feather>
                            <span>{{$t(`sidebar.${item.moduleName}`)}} </span>
                            <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                        </a>



                        <p class="sidebar-link single_click only-link sidebar-group-label"
                           v-if="!item.subModules && item.moduleCode!='999999999' && item.categoryModules!=null"
                           :title="[$t(`sidebar.${item.moduleName}`)]"
                           :active="index === activeIndex" :attribute-id="[item.moduleId]">
                            <span>{{$t(`sidebar.${item.moduleName}`)}} </span>
                            <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                        </p>
                        <a href=" https://crm.fraxioned.com/" target="_blank" class="sidebar-link single_click only-link"
                           v-if="!item.subModules && item.moduleCode=='999999999' && item.categoryModules!=null"
                           :title="[$t(`sidebar.${item.moduleName}`)]"
                           :class="[{'active':checkCurrentRoute(item)},'menuElelment_'+ item.moduleId]"
                           :active="index === activeIndex" :attribute-id="[item.moduleId]">
                            <vue-feather :type="item.moduleCssClass"></vue-feather>
                            <span>{{$t(`sidebar.${item.moduleName}`)}} </span> 
                            <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                        </a>
                        <ul>
                            <li v-for="(mainCatgory,activeIndex1) in item.categoryModules">
                                <a href="javascript:void(0)" class="sidebar-link single_click only-link"
                                   v-if="!mainCatgory.subModules && mainCatgory.moduleCode!='999999999'"
                                   @click="mainCatgory.moduleCode == 1099 ||1097 ? handleDocumentVaultClick(mainCatgory) : redirectToPath(mainCatgory.moduleRoute)" :title="[$t(`sidebar.${mainCatgory.moduleName}`)]"
                                   :class="{'active': checkCurrentRoute(mainCatgory)}"
                                   :active="index === activeIndex1" :attribute-id="[mainCatgory.moduleId]">

                                    <vue-feather :type="mainCatgory.moduleCssClass"></vue-feather>
                                    <span>{{$t(`sidebar.${mainCatgory.moduleName}`)}} </span>
                                    <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                                </a>


                                <a href="javascript:void(0)" class="sidebar-link"
                                   v-if="mainCatgory.subModules  && mainCatgory.moduleCode!='999999999'"
                                   v-bind:attribute-id="[mainCatgory.moduleId]"
                                   :title="[$t(`sidebar.${mainCatgory.moduleName}`)]"
                                   @click="onMenuWithChildrenClick(mainCatgory, $event)"
                                   :class="[{'active':checkParentRoute(mainCatgory.moduleCode)}, 'sidebar-link multiple_click sub_moduleRoute addhighlited_' + mainCatgory.moduleId]">
                                    <vue-feather :type="mainCatgory.moduleCssClass"></vue-feather>

                                    <span>{{$t(`sidebar.${mainCatgory.moduleName}`)}} </span>
                                    <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                                </a>
                                <ul :id="submenuDomId(mainCatgory)"
                                    :class="[{'show':isSubmenuExpanded(mainCatgory)},'nav-submenu collapse menu-content menuElelment_'+ mainCatgory.moduleId]" v-if="mainCatgory.subModules">

                                    <li v-for="childItem in mainCatgory.subModules" v-bind:key="childItem.moduleId" >

                                        <a v-if="!childItem.subModules && !childItem.isForRightMenu &&  childItem.moduleCode!=1024 && childItem.moduleCode!=9011012" href="Javascript:;" :class="{'active':checkCurrentRoute(childItem)}"
                                           :title="[$t(`sidebar.${childItem.moduleName}`)]" 
                                           @click="childItem.moduleCode == 1100 || 1098 ? handleDocumentVaultChildClick(childItem) : redirectToPath(childItem.moduleRoute)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-right"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>
                                            <span :style="(childItem.moduleName === 'Ebook Subscribers' || childItem.moduleName === 'Free Trial Leads')
    ? 'text-transform: none !important;'
    : ''">{{$t(`sidebar.${childItem.moduleName.replace("'",'')}`)}} </span>
                                        </a>

                                        <a v-if="!childItem.subModules && !childItem.isForRightMenu && ( childItem.moduleCode==1024 || childItem.moduleCode==9011012)" href="Javascript:;" :class="{'active':checkCurrentRoute(childItem)}"
                                           :title="childItem.moduleName" @click="redirectToPath(childItem.moduleRoute)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-right"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>
                                            <span>{{childItem.moduleName}} </span>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li class="sidebar-link only-link" :class="{ 'mobile-hide': loginSource == 'Mobile' }">
                        <a href="javascript:void(0)" @click="logout()" class="sidebar-link single_click only-link">

                            <!--<vue-feather :type="mainCatgory.moduleCssClass"></vue-feather>-->
                            <i class="fa fa-power-off" aria-hidden="true"></i>
                            <span>Logout </span>
                            <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>




</template>

<loading v-model:active="isLoading" />
<script>
    import service from '@/service/CompanyUserServices/CompanyUserService.js';
    import {
        CO_OWNER_MENU_UPDATED_EVENT,
        getManageOwnedAssetsPostLoginRoute,
        shouldRestrictCoOwnerMenuSync
    } from '@/helpers/coOwnerSidebarMenu';
    import {
        loadSidebarModuleList,
        SIDEBAR_MENU_UPDATED_EVENT
    } from '@/helpers/sidebarMenuUtils';
    import {
        expandSidebarShell,
        initShellLayoutWhenReady,
        isShellDesktopViewport,
        isSidebarCollapsed,
        syncSidebarShellState
    } from '@/helpers/shellLayout';
    import {
        rootGroupParentLiClass,
        shouldShowSidebarMenuIcon
    } from '@/helpers/assetManagerSidebarMenu';
    import {
        COMPANY_LOGOS_UPDATED_EVENT,
        applyLogoImgDomSrc,
        resolveSidebarLogoDisplaySrc,
        resolveSidebarLogoPrimary
    } from '@/helpers/companyLogos';
    import {
        isManageAssetsListRoute,
        navigateToManageAssets,
        isManageAssetsNavigationInFlight,
        buildManageAssetDetailPath
    } from '@/helpers/manageAssetsNavigation';
    import SimpleDialog from "@/views/shared/SimpleDialog.vue";

    import { createConfirmDialog } from "vuejs-confirm-dialog";
    import UserService from '@/service/user.service';
    import { isHouseholdAssetType } from '@/helpers/expenseCreateRoute.js';
    import { applyDynamicTerminology } from '@/helpers/dynamicUiText.js';
    import { notifyNativeLogout } from '@/utils/nativeBridge';
    import {
        captureRememberMeCredentials,
        restoreRememberMeCredentials,
    } from '@/helpers/rememberMeCredentials';
    //mport Loading from 'vue-loading-overlay';

    export default {
        name: 'HelloWorld',
        props: {
            msg: String

        }, components: {

        },
        data() {

            let name = {
                firstName: '',
                lastName: ''
            }

            return {
                form: {
                    username: "",
                    password: "",
                    isLoading: false
                },
                companyId: localStorage.getItem("companyId"), assetType: localStorage.getItem('assetType'),
                hostUrl: location.host,
                roomderaHost: process.env.VUE_APP_ROOMDERA_HOST,
                boatderaHost: process.env.VUE_APP_BOATDERA_HOST,
                planederaHost: process.env.VUE_APP_PLANEDERA_HOST,
                kidsderaHost: process.env.VUE_APP_KIDSDERA_HOST,
                bizderaHost: process.env.VUE_APP_BIZDERA_HOST,
                parentderaHost: process.env.VUE_APP_PARENTDERA_HOST,
                homederaHost: process.env.VUE_APP_HOMEDERA_HOST,
                rvderaHost: process.env.VUE_APP_RVDERA_HOST,
                briktokHost: process.env.VUE_APP_BRIKTOK_HOST,

                showError: false, headerData: null, imageLink: null, name, logoPrimary: null, logoSecondary: null,
                isLoading: false, moduleList: [], activeIndex: 0, loginSource: localStorage.getItem('loginSource'),
                ownedAssetsNavInFlight: false,
                logoPrimary: localStorage.getItem('primaryLogo'),
                logoSecondary: localStorage.getItem('secondaryLogo'),
                expandedModuleIds: [],
                forceCollapsedModuleIds: [],

                Svg: ' <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>'
            };
        },
        created() {
            this.refreshLogosFromStorage();

            if (window.location.pathname == '/account/setpassword') {
                //window.localStorage.clear();
                //window.location.reload();

            }
            this.GetHeaderData();
            var data = JSON.parse(localStorage.getItem('userinfo')).data;
            this.name = data;
            this.GetModuleList();
        },
        mounted() {
            this._onCoOwnerMenuUpdated = () => {
                this.GetModuleList();
            };
            this._onCompanyLogosUpdated = () => {
                this.refreshLogosFromStorage();
            };
            this._onSidebarMenuUpdated = () => {
                this.GetModuleList();
            };
            window.addEventListener(CO_OWNER_MENU_UPDATED_EVENT, this._onCoOwnerMenuUpdated);
            window.addEventListener(COMPANY_LOGOS_UPDATED_EVENT, this._onCompanyLogosUpdated);
            window.addEventListener(SIDEBAR_MENU_UPDATED_EVENT, this._onSidebarMenuUpdated);
            this.$nextTick(() => {
                initShellLayoutWhenReady();
            });
        },
        unmounted() {
            if (this._onCoOwnerMenuUpdated) {
                window.removeEventListener(CO_OWNER_MENU_UPDATED_EVENT, this._onCoOwnerMenuUpdated);
            }
            if (this._onCompanyLogosUpdated) {
                window.removeEventListener(COMPANY_LOGOS_UPDATED_EVENT, this._onCompanyLogosUpdated);
            }
            if (this._onSidebarMenuUpdated) {
                window.removeEventListener(SIDEBAR_MENU_UPDATED_EVENT, this._onSidebarMenuUpdated);
            }
        },
        computed: {
            currentRouteKey() {
                return `${this.$route.path}|${this.$route.meta?.moduleCode ?? ''}`;
            },
            allMenuPaths() {
                return this.collectMenuPaths(this.moduleList);
            }
        },
        watch: {
            currentRouteKey() {
                // Allow route-driven expansion again after navigation
                this.forceCollapsedModuleIds = [];
            }
        },
        methods: {
            postToSidebarDocumentVaultChannel(payload = {}) {
                if (this.isMobileLoginSource() && window.DocumentVaultChannel) {
                  
                    window.DocumentVaultChannel.postMessage(
                        JSON.stringify({
                            userId: localStorage.getItem('userId'),
                            token: localStorage.getItem('access_token'),
                            companyId: localStorage.getItem('companyId'),
                            ...payload
                        })
                    );
                    return false; // native handled it
                }
                return false; // web (or bridge not present) ? caller should fall back
            },
            /** Household companies show "Roommate" instead of "Co-owner" in the profile chip. */
            formatHeaderUserType(userType) {
                const label = String(userType || '').trim();
                if (!label) return '';
                if (isHouseholdAssetType() && /^co-?\s*owner$/i.test(label)) {
                    return 'Roommate';
                }
                return applyDynamicTerminology(label);
            },
            async handleDocumentVaultClick(mainCatgory) {
                debugger;
                // Safety check: only ever run this for the Document Vault module
                if (mainCatgory.moduleCode != 1099 && mainCatgory.moduleCode != 1097) {
                    this.redirectToPath(mainCatgory.moduleRoute);
                    return;
                }

                // Let native handle it on Mobile, if the bridge is present
                if (this.postToSidebarDocumentVaultChannel({ moduleCode: mainCatgory.moduleCode })) {
                    this.closeSidebarForMobileLogin();
                    return;
                }

                if (mainCatgory.moduleCode == 1097) {
                    this.isLoading = true;
                    try {
                        const companyId = localStorage.getItem('companyId');
                        const result = await service.AssetListDropdown(companyId);
                        const assets = result?.data || [];

                        if (assets.length === 1) {
                            // Only one asset -> go straight to its Document Vault
                            await this.$router.push({ path: `/manageassets/sharehistory/${assets[0].Id}` });
                        } else {
                            // Multiple assets -> let user pick one first
                            await this.$router.push({ path: '/manageassets' });
                        }
                        this.closeSidebarForMobileLogin();
                    } catch (ex) {
                        console.log('handleDocumentVaultChildClick error', ex);
                        this.redirectToPath(mainCatgory.moduleRoute); // fallback to old behavior
                    } finally {
                        this.isLoading = false;
                    }
                } else {
                    this.isLoading = true;
                    try {
                        const companyId = localStorage.getItem('companyId');
                        const result = await service.AssetListDropdown(companyId);
                        const assets = result?.data || [];

                        if (assets.length === 1) {
                            // Only one asset -> go straight to its Document Vault
                            await this.$router.push({ path: `/ManageDocuments/${assets[0].Id}` });
                        } else {
                            // Multiple assets -> let user pick one first
                            await this.$router.push({ path: '/ownedProperties' });
                        }
                        this.closeSidebarForMobileLogin();
                    } catch (ex) {
                        console.log('handleDocumentVaultClick error', ex);
                        this.redirectToPath(mainCatgory.moduleRoute); // fallback to old behavior
                    } finally {
                        this.isLoading = false;
                    }
                }
               
            },
            async handleDocumentVaultChildClick(mainCatgory) {
                debugger;
                // Safety check: only ever run this for the Document Vault module
                if (mainCatgory.moduleCode != 1100 && mainCatgory.moduleCode != 1098) {
                    this.redirectToPath(mainCatgory.moduleRoute);
                    return;
                }

                // Let native handle it on Mobile, if the bridge is present
                if (this.postToSidebarDocumentVaultChannel({ moduleCode: mainCatgory.moduleCode })) {
                    this.closeSidebarForMobileLogin();
                    return;
                }

                if (mainCatgory.moduleCode == 1098) {
                    this.isLoading = true;
                    try {
                        const companyId = localStorage.getItem('companyId');
                        const result = await service.AssetListDropdown(companyId);
                        const assets = result?.data || [];

                        if (assets.length === 1) {
                            // Only one asset -> go straight to its Document Vault
                            await this.$router.push({ path: `/manageassets/sharehistory/${assets[0].Id}` });
                        } else {
                            // Multiple assets -> let user pick one first
                            await this.$router.push({ path: '/manageassets' });
                        }
                        this.closeSidebarForMobileLogin();
                    } catch (ex) {
                        console.log('handleDocumentVaultChildClick error', ex);
                        this.redirectToPath(mainCatgory.moduleRoute); // fallback to old behavior
                    } finally {
                        this.isLoading = false;
                    }
                }
                else {
                    this.isLoading = true;
                    try {
                        const companyId = localStorage.getItem('companyId');
                        const result = await service.AssetListDropdown(companyId);
                        const assets = result?.data || [];

                        if (assets.length === 1) {
                            // Only one asset -> go straight to its Document Vault
                            await this.$router.push({ path: `/ManageDocuments/${assets[0].Id}` });
                        } else {
                            // Multiple assets -> let user pick one first
                            await this.$router.push({ path: '/manageassets' });
                        }
                        this.closeSidebarForMobileLogin();
                    } catch (ex) {
                        console.log('handleDocumentVaultChildClick error', ex);
                        this.redirectToPath(mainCatgory.moduleRoute); // fallback to old behavior
                    } finally {
                        this.isLoading = false;
                    }
                }
            },
            rootGroupParentLiClass,
            shouldShowSidebarMenuIcon,
            refreshLogosFromStorage() {
                this.logoSecondary = localStorage.getItem('secondaryLogo');
                this.logoPrimary = resolveSidebarLogoPrimary();
                applyLogoImgDomSrc(resolveSidebarLogoDisplaySrc(this.companyId));
            },
            isMobileLoginSource() {
                const source = String(
                    this.loginSource || localStorage.getItem('loginSource') || ''
                ).toLowerCase();
                return source === 'mobile';
            },
            /** Hide sidebar after menu navigation for Mobile login only; no-op for Web. */
            closeSidebarForMobileLogin() {
                if (!this.isMobileLoginSource()) {
                    return;
                }
                this.$nextTick(() => {
                    document.getElementById('top-page-header')?.classList.add('close_icon');
                    document.getElementById('nav-page-sidebar')?.classList.add('close_icon');
                });
            },
            CheckRoute() {
                this.closeSidebarForMobileLogin();
            },
            goToHomeRoute() {
                if (this.userType == 'usertype21') {
                    if (localStorage.getItem('isAssetAssigned') == false || localStorage.getItem('isAssetAssigned') == 'false') {
                        this.$router.push('/manageassets');
                    } else {
                        this.$router.push('/dashboard');
                    }
                } else {
                    const path = shouldRestrictCoOwnerMenuSync()
                        ? getManageOwnedAssetsPostLoginRoute()
                        : '/dashboard';
                    this.$router.push(path);
                }
                this.closeSidebarForMobileLogin();
            },
            async logout() {
                try {
                    /*const IPAddress = await UserService.GetIPAddress();*/
                    const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                        question: `${this.$t('ConfirmMessage.LogoutConfirm')}`,
                        header: `${this.$t('ConfirmMessage.Logout')}`,
                        cancel: `${this.$t('ConfirmMessage.Cancel')}`,
                        confirm: `${this.$t('ConfirmMessage.Logout')}`,
                    });

                    onConfirm(() => {
                        this.isLoading = true;
                        UserService.LogoutHistory(localStorage.getItem('userId'), localStorage.getItem("usedcurrentIP")).then(res => {
                        })
                        UserService.Logout(localStorage.getItem('userId')).then(res => {
                        })
                        if (document.getElementById('sidebar') != null) {
                            document.getElementById('sidebar').setAttribute("class", "sidebar js-sidebar collapsed");
                            if (document.getElementById('main_full') != null) {
                                document.getElementById('main_full').setAttribute("class", "main full-section-cc");
                            }
                        }

                        setTimeout(() => {
                            let userType = JSON.parse(localStorage.getItem('userinfo')).data.userType;
                            let companyUrl = localStorage.getItem('companyUrl')
                            let backOrigin = localStorage.getItem('backOrigin')
                            var sessionData = localStorage.getItem('adminTheme');
                            // Notify native shell before clearing session (no-op on web).
                            notifyNativeLogout();
                            localStorage.clear();
                            localStorage.setItem("adminTheme", sessionData);
                            if ((userType == ('usertype07') || userType == ('usertype05') || userType == ('usertype10') || userType == ('usertype03')
                                || userType == ('usertype09') || userType == ('usertype11') || userType == ('usertype12'))
                                && this.$filters.IsNull(companyUrl, true, null) != null) {
                                if (backOrigin != null && backOrigin != '') {

                                    window.location.assign(`https://${backOrigin}/home`)
                                }
                                else if (this.$custConfig.companyPortalUrl != null && this.$custConfig.companyPortalUrl != undefined) {
                                    window.location.assign(`${this.$custConfig.companyPortalUrl}/logoutRedirect/${companyUrl}`)
                                } else {
                                    window.location.href = "/login";
                                }
                            }
                            else {
                                window.location.href = "/login";
                            }


                            this.$toast.success(this.$t('Toaster.SessionLogout'));
                        }, 500);
                    });
                    reveal(() => {
                        this.data = "";
                    });
                } catch (ex) {
                    console.log("messagessssssssssss", ex.Message)
                }


            },
            normalizeMenuPath(path) {
                if (path == null || path === '') {
                    return '';
                }
                const raw = String(path).trim();
                if (!raw || raw.startsWith('http://') || raw.startsWith('https://')) {
                    return raw;
                }
                return raw.startsWith('/') ? raw : `/${raw}`;
            },
            submenuDomId(menu) {
                const route = String(menu?.moduleRoute || menu?.moduleId || '').replace(/[^a-zA-Z0-9_-]/g, '_');
                return `sidebar-submenu-${route || menu?.moduleId}`;
            },
            collectMenuPaths(modules, paths = []) {
                if (!Array.isArray(modules)) {
                    return paths;
                }
                modules.forEach((mod) => {
                    const menuPath = this.normalizeMenuPath(mod?.moduleRoute);
                    if (menuPath && !menuPath.startsWith('http://') && !menuPath.startsWith('https://')) {
                        paths.push(menuPath);
                    }
                    this.getAlternateMenuPaths(mod).forEach((altPath) => {
                        if (altPath && !paths.includes(altPath)) {
                            paths.push(altPath);
                        }
                    });
                    this.collectMenuPaths(mod?.categoryModules, paths);
                    this.collectMenuPaths(mod?.subModules, paths);
                });
                return paths;
            },
            getAlternateMenuPaths(item) {
                if (!item) {
                    return [];
                }
                // Document Vault navigates to /ManageDocuments/:id (not its configured moduleRoute)
                if (item.moduleCode == 1099) {
                    return ['/ManageDocuments', '/manageassets/ManageDocuments'];
                }
                return [];
            },
            hasMoreSpecificMenuPathMatch(menuPath, currentPath) {
                return this.allMenuPaths.some((path) =>
                    path !== menuPath
                    && path.startsWith(`${menuPath}/`)
                    && (currentPath === path || currentPath.startsWith(`${path}/`))
                );
            },
            isPathActiveForMenu(menuPath, currentPath) {
                if (!menuPath || !currentPath) {
                    return false;
                }
                if (currentPath === menuPath) {
                    return true;
                }
                if (currentPath.startsWith(`${menuPath}/`)) {
                    return !this.hasMoreSpecificMenuPathMatch(menuPath, currentPath);
                }
                return false;
            },
            isMenuItemActive(item) {
                void this.currentRouteKey;
                if (!item) {
                    return false;
                }
                const currentModuleCode = this.$route?.meta?.moduleCode;
                if (currentModuleCode != null && item.moduleCode != null && item.moduleCode == currentModuleCode) {
                    return true;
                }
                const currentPath = this.$route?.path || '';
                const menuPath = this.normalizeMenuPath(item.moduleRoute);
                if (menuPath && !menuPath.startsWith('http://') && !menuPath.startsWith('https://')) {
                    if (this.isPathActiveForMenu(menuPath, currentPath)) {
                        return true;
                    }
                }
                return this.getAlternateMenuPaths(item).some((altPath) =>
                    this.isPathActiveForMenu(altPath, currentPath)
                );
            },
            isMenuTreeActive(mod) {
                void this.currentRouteKey;
                if (!mod) {
                    return false;
                }
                if (this.isMenuItemActive(mod)) {
                    return true;
                }
                if (Array.isArray(mod.subModules) && mod.subModules.some((child) => this.isMenuTreeActive(child))) {
                    return true;
                }
                if (Array.isArray(mod.categoryModules) && mod.categoryModules.some((child) => this.isMenuTreeActive(child))) {
                    return true;
                }
                return false;
            },
            findModuleByCode(modules, modulCode) {
                if (!Array.isArray(modules) || modulCode == null) {
                    return null;
                }
                for (const mod of modules) {
                    if (mod.moduleCode == modulCode) {
                        return mod;
                    }
                    const inCategory = this.findModuleByCode(mod.categoryModules, modulCode);
                    if (inCategory) {
                        return inCategory;
                    }
                    const inSub = this.findModuleByCode(mod.subModules, modulCode);
                    if (inSub) {
                        return inSub;
                    }
                }
                return null;
            },
            checkCurrentRoute(item) {
                return this.isMenuItemActive(item);
            },
            async GetModuleList() {
                this.isLoading = true;
                try {
                    this.moduleList = await loadSidebarModuleList();
                } catch (ex) {
                    this.moduleList = [];
                    console.log("GetModuleList", ex);
                } finally {
                    this.isLoading = false;
                }
            },
            goToEditSidebar() {
                this.$router.push('/edit-sidebar');
            },
            checkParentRoute(modulCode) {
                if (modulCode == null) {
                    return false;
                }
                const parent = this.findModuleByCode(this.moduleList, modulCode);
                return this.isMenuTreeActive(parent);
            },
            isSubmenuExpanded(menu) {
                if (!menu) {
                    return false;
                }
                if (this.forceCollapsedModuleIds.includes(menu.moduleId)) {
                    return false;
                }
                if (this.checkParentRoute(menu.moduleCode)) {
                    return true;
                }
                return this.expandedModuleIds.includes(menu.moduleId);
            },

            ForSrceenChange() {
                syncSidebarShellState();
            },
            menuHasChildren(menu) {
                return Array.isArray(menu?.subModules) && menu.subModules.length > 0;
            },
            onMenuWithChildrenClick(menu, event) {
                if (!this.menuHasChildren(menu)) {
                    return;
                }

                // Own expand/collapse in one click (avoid Bootstrap + jQuery double-handling)
                event.preventDefault();
                event.stopPropagation();

                if (isSidebarCollapsed() && isShellDesktopViewport()) {
                    expandSidebarShell();
                }

                const id = menu.moduleId;
                if (this.isSubmenuExpanded(menu)) {
                    this.expandedModuleIds = this.expandedModuleIds.filter((moduleId) => moduleId !== id);
                    if (!this.forceCollapsedModuleIds.includes(id)) {
                        this.forceCollapsedModuleIds = [...this.forceCollapsedModuleIds, id];
                    }
                } else {
                    this.forceCollapsedModuleIds = this.forceCollapsedModuleIds.filter((moduleId) => moduleId !== id);
                    if (!this.expandedModuleIds.includes(id)) {
                        this.expandedModuleIds = [...this.expandedModuleIds, id];
                    }
                }
            },
            async redirectToPath(path) {
                if (path == 'home') {
                    window.location.assign(`${this.$custConfig.companyPortalUrl}/${localStorage.getItem('companyUrl')}/Home`)
                    return;
                }

                // Remember whether the sidebar was collapsed
                const wasCollapsed = isSidebarCollapsed() && isShellDesktopViewport();

                if (!wasCollapsed) {
                    this.ForSrceenChange();
                }

                if (path == null || path === '') {
                    return;
                }

                const raw = typeof path === 'string' ? path.trim() : path;
                const normalizedPath =
                    typeof raw === 'string' &&
                        raw !== '' &&
                        !raw.startsWith('/') &&
                        !raw.startsWith('http://') &&
                        !raw.startsWith('https://')
                        ? `/${raw}`
                        : raw;

                if (isManageAssetsListRoute(normalizedPath)) {
                    if (isManageAssetsNavigationInFlight()) {
                        return;
                    }

                    await navigateToManageAssets(this.$router, {
                        setLoading: (active) => {
                            this.isLoading = active;
                        }
                    });
                    this.closeSidebarForMobileLogin();
                    return;
                }

                if (this.isOwnedPropertiesListRoute(normalizedPath)) {
                    await this.navigateToOwnedProperties();
                    return;
                }

                // Wait for the route to finish changing
                try {
                    await this.$router.push(normalizedPath);
                } catch (navError) {
                    // Ignore duplicate-navigation rejections; still close for Mobile.
                }

                // Restore the collapsed state (existing Web/desktop behavior)
                if (wasCollapsed) {
                    this.$nextTick(() => {
                        document.getElementById("top-page-header")?.classList.add("close_icon");
                        document.getElementById("nav-page-sidebar")?.classList.add("close_icon");
                    });
                }

                // Mobile login: always close sidebar after a navigable menu click
                this.closeSidebarForMobileLogin();
            },
            isOwnedPropertiesListRoute(path) {
                const raw = String(path || '').trim().toLowerCase();
                if (!raw) {
                    return false;
                }
                const normalized = raw.startsWith('/') ? raw : `/${raw}`;
                return normalized === '/ownedproperties';
            },
            async navigateToOwnedProperties() {
                if (this.ownedAssetsNavInFlight) {
                    return;
                }

                this.ownedAssetsNavInFlight = true;
                this.isLoading = true;
                try {
                    const result = await service.GetOwnedPropertList({
                        searchItem: null,
                        status: '1',
                        sortColumn: 'ModifiedOn',
                        sortDir: 'desc',
                        pageIndex: 0,
                        pageSize: 2,
                        userId: localStorage.getItem('userId'),
                        companyId: localStorage.getItem('companyId')
                    });
                    const items = result?.data?.data || [];
                    const totalRecords = items.length > 0 ? Number(items[0].TotalRecord) : 0;
                    const assetId = items[0]?.AssetID;

                    if (totalRecords === 1 && assetId) {
                        await this.$router.push({ path: buildManageAssetDetailPath(assetId) });
                    } else {
                        await this.$router.push({ path: '/ownedProperties' });
                    }
                } catch (error) {
                    console.warn('Owned properties navigation failed', error);
                    try {
                        await this.$router.push({ path: '/ownedProperties' });
                    } catch {
                        // ignore duplicate-navigation rejections
                    }
                } finally {
                    this.ownedAssetsNavInFlight = false;
                    this.isLoading = false;
                    this.closeSidebarForMobileLogin();
                }
            },

            GetHeaderData() {

                UserService.getHeaderData(localStorage.getItem("userId"), '00Test').then(res => {
                    this.headerData = res.data;
                    this.imageLink = res.data.profilePic;

                })
            },
            async logout() {
                try {
                    const IPAddress = await UserService.GetIPAddress();
                    const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                        question: `Are you sure you want to log out?`,
                        header: `Logout`,
                        cancel: `Cancel`,
                        confirm: `Log Out`,
                    });

                    onConfirm(() => {
                        this.isLoading = true;
                        if (document.getElementById('sidebar') != null) {
                            document.getElementById('sidebar').setAttribute("class", "sidebar js-sidebar collapsed");
                            if (document.getElementById('main_full') != null) {
                                document.getElementById('main_full').setAttribute("class", "main full-section-cc");
                            }
                        }

                        setTimeout(() => {
                            UserService.LogoutHistory(localStorage.getItem('userId'), IPAddress).then(res => {

                            })
                            let userType = JSON.parse(localStorage.getItem('userinfo')).data.userType;
                            let companyDomainName = JSON.parse(localStorage.getItem('userinfo')).data.companyDomainName;
                            let companyUrl = localStorage.getItem('companyUrl')
                            const rememberMe = captureRememberMeCredentials();
                            // Notify native shell before clearing session (no-op on web).
                            notifyNativeLogout();
                            localStorage.clear();
                            restoreRememberMeCredentials(rememberMe);
                            //if ((userType == ('usertype03') || userType == ('usertype05') || userType == ('usertype07') ||  userType == ('usertype10') ||  userType == ('usertype09') || userType == ('usertype08') || userType == ('usertype12') ) && this.$filters.IsNull(companyUrl, true, null) != null) {
                            if ((userType != ('usertype01') || userType != ('usertype02') || userType != ('usertype04') || userType != ('usertype06')) && this.$filters.IsNull(companyUrl, true, null) != null) {
                                if (this.$filters.IsNull(companyDomainName, true, null) != null) {
                                    window.location.assign(`${companyDomainName}/logoutRedirect/${companyUrl}`)
                                }
                                else if (this.$custConfig.companyPortalUrl != null && this.$custConfig.companyPortalUrl != undefined) {
                                    window.location.assign(`${this.$custConfig.companyPortalUrl}/logoutRedirect/${companyUrl}`)
                                } else {
                                    window.location.href = "/login";
                                }
                            }
                            else {
                                window.location.href = "/login";
                            }
                            this.$toast.success(`Your session has been successfully logged out.`);
                        }, 500);
                    });
                    reveal(() => {
                        this.data = "";
                    });
                } catch (ex) {
                    console.log("messagessssssssssss", ex.Message)
                }


            },

            toggleSlider() {
                const headerElement = document.getElementById("top-page-header");
                const sideElement = document.getElementById("nav-page-sidebar");

                headerElement.classList.toggle("close_icon");
                sideElement.classList.toggle("close_icon");
            },

            sidebarMouseEnter() {
                document.getElementById("top-page-header").classList.remove("close_icon");
                document.getElementById("nav-page-sidebar").classList.remove("close_icon");
            },

            sidebarMouseLeave() {
                document.getElementById("top-page-header").classList.add("close_icon");
                document.getElementById("nav-page-sidebar").classList.add("close_icon");
            },

        }
    }
</script>

<style scoped>
    #mainsidebar .sidebar-menu.custom-scrollbar .edit-sidebar-action {
        padding: 8.7px 10px 8.7px 10px;
        margin-bottom: 0px;
    }

    #mainsidebar .sidebar-menu.custom-scrollbar .edit-sidebar-action::before {
        display: none !important;
    }



.edit-sidebar-cta {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 5px;
    border: none;
    border-radius: 5px;
    color: #fff;
    background:#945e00;
    cursor: pointer;
    transition:
        transform 250ms ease,
        box-shadow 250ms ease,
        background 250ms ease,
        filter 250ms ease;
}

    .edit-sidebar-cta:hover {
        color: #945e00;
        background: #fff;
        box-shadow: 0 8px 22px rgba(0, 136, 232, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.14) inset;
    }



.edit-sidebar-cta:active {
    transform: scale(1.01);
    transition-duration: 150ms;
}

.edit-sidebar-cta__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    font-size: 14px;
    flex-shrink: 0;
}

.edit-sidebar-cta__label {
    white-space: nowrap;
}

:global(body.light) .edit-sidebar-action::after {
    background: rgba(0, 0, 0, 0.08);
}
</style>
